import React from "react";
import { Link } from "react-router-dom";
import prog1 from "../../assets/header-images/prog1.jpg";
import tools1 from "../../assets/header-images/tools1.jpg";
import life1 from "../../assets/header-images/life1.jpg";
import "../../css/MainPage/MainLanding.css";

const sections = [
  {
    title: "Programs",
    description:
      "Explore a wide range of academic, professional, and enrichment programs, including research opportunities, study abroad, mentorship, conferences, STEM programs, and more.",
    image: prog1,
    link: "/programs",
    button: "Explore Programs",
  },
  {
    title: "Tools",
    description:
      "Access helpful tools for your college journey, such as GPA calculators, scholarship search, financial trackers, AI tools, and more to support your academic and financial success.",
    image: tools1,
    link: "/tools",
    button: "Explore Tools",
  },
];

export default function Resources() {
  return (
    <div className="main-landing-page" style={{ minHeight: "100vh" }}>
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${life1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>Resources for College Success</h1>
          <div className="main-landing-hero-sub">
            Discover programs and tools to help you thrive in your academic and
            professional journey.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div
        className="main-landing-mission-section"
        style={{ padding: "2.5rem 0 1.5rem 0" }}
      >
        <div className="main-landing-mission-container">
          <h2>Empower Your College Experience</h2>
          <p>
            From academic programs to practical tools, our resources are
            designed to support every aspect of your college life. Explore
            opportunities, enhance your skills, and make the most of your
            education with CollegeNav's curated resources.
          </p>
        </div>
      </div>

      {/* Main Sections */}
      <div style={{ background: "#f8fafc", padding: "3.5rem 0" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
            gap: "2.2rem",
            maxWidth: 900,
            margin: "0 auto",
            padding: "0 1.5rem",
          }}
        >
          {sections.map((section, idx) => (
            <div key={idx} className="afford-college-card">
              <div className="afford-college-card-image">
                <img src={section.image} alt={section.title} />
              </div>
              <div className="afford-college-card-content">
                <div>
                  <div className="afford-college-card-title">
                    {section.title}
                  </div>
                  <div className="afford-college-card-desc">
                    {section.description}
                  </div>
                </div>
                <Link to={section.link} className="afford-college-link-btn">
                  {section.button}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
